export default {
  name: 'objectManagement',
  data () {
    /* 校验手机号 */
    var checkPhone = (rule, value, callback) => {
      const phoneReg = /^1[3|4|5|7|8][0-9]{9}$/
      if (!value) {
        return callback(new Error('电话号码不能为空'))
      }
      setTimeout(() => {
        if (!Number.isInteger(+value)) {
          callback(new Error('请输入数字值'))
        } else {
          if (phoneReg.test(value)) {
            callback()
          } else {
            callback(new Error('电话号码格式不正确'))
          }
        }
      }, 100)
    }
    /* 校验邮箱 */
    var checkEmail = (rule, value, callback) => {
      const mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/
      if (!value) {
        return callback(new Error('邮箱不能为空'))
      }
      setTimeout(() => {
        if (mailReg.test(value)) {
          callback()
        } else {
          callback(new Error('请输入正确的邮箱格式'))
        }
      }, 100)
    }
    return {
      page: {
        num: 1,
        size: 10
      },
      totalRows: 100,
      labelPosition: 'right',
      formInline: {
        objectName: '',
        sysId: '',
        telNum: ''
      },
      appKeyList: [],
      appOp: [], // 通过详情查询应用数组
      tooltip: true,
      tableList: [],
      dialogFormVisible: false,
      dialogTitle: {
        addObj: '新增预警对象',
        editObj: '编辑预警对象'
      },
      dialogStatus: '',
      objForm: {
        objectId: '',
        sysId: '',
        objectName: '',
        appKey: [],
        telNum: '',
        email: '',
        objectDesc: ''
      },
      rules: {
        objectName: [
          { required: true, message: '请输入对象名称', trigger: 'blur' }
        ],
        sysId: [
          { required: true, message: '请选择业务系统', trigger: 'change' }
        ],
        telNum: [{ required: true, validator: checkPhone, trigger: 'blur' }],
        email: [{ required: true, validator: checkEmail, trigger: 'blur' }]
      }
    }
  },
  created () {
    this.$store.dispatch('getSystem') // 请求业务系统
    let op = {}
    op.appOwner = 1
    let _this = this
    this.$http
      .post(_this.$API.pay.queryAllAppInfo, {}, { headers: op })
      .then(function(r) {
        _this.appKeyList = r.data.resData
      })
      .catch(function(error) { console.log(error) })
    this.queryList()
  },
  computed: {
    sysData () {
      return this.$store.state.sysData
    }
  },
  methods: {
    /* 查询预警对象列表 */
    queryList () {
      let id = this.formInline.sysId
      let sysIds = []
      if (id && id !== 0) {
        sysIds.push(id)
      }
      let params = {
        pageNum: this.page.num,
        pageSize: this.page.size,
        telNum: this.formInline.telNum,
        sysIds: sysIds,
        objectName: this.formInline.objectName
      }
      let _self = this
      this.$axios
        .post(this.$API.warning.queryAlarmObjectListByPage, params)
        .then(function (r) {
          _self.tableList = r.data.resData.resultList
          _self.totalRows = r.data.resData.total
        })
        .catch(function (error) {})
    },
    /* 点击查询按钮 */
    onSearch () {
      this.page.num = 1
      this.queryList()
    },
    /* 新增 */
    handleAdd () {
      this.dialogFormVisible = true
      this.dialogStatus = 'addObj'
    },
    /* 编辑 */
    handleEdit (index, row) {
      this.dialogFormVisible = true
      this.dialogStatus = 'editObj'
      let _self = this
      this.$http
        .get(this.$API.warning.queryAlarmObjectById, {
          // .get('http://172.16.9.104:5010/agw/alarmObjectCtr/queryAlarmObjectById', {
          params: { objectId: row.objectId }
        })
        .then(function (r) {
          let data = r.data.resData
          _self.objForm.objectId = data.objectId
          _self.appOp = data.appKeyList
          let appOp = []
          for (let v of data.appKeyList) {
            if (v.appKey) {
              appOp.push(v.appKey)
            }
          }
          _self.objForm.appKey = appOp
          _self.objForm.objectName = data.objectName
          _self.objForm.telNum = data.telNum
          _self.objForm.email = data.email
          _self.objForm.sysId = Number(data.sysId)
          _self.objForm.objectDesc = data.objectDesc
        })
        .catch(function (error) {})
    },
    /* 根据状态保存新增/编辑预警对象 */
    saveObj (formName) {
      let _this = this
      if (this.dialogStatus == 'editObj') {
        this.$refs[formName].validate(valid => {
          if (valid) {
            let _self = this
            let sysIds = []
            if (this.objForm.sysId) {
              sysIds.push(this.objForm.sysId)
            }
            let appOP = []
            _this.objForm.appKey.forEach((v) => {
              let list = {}
              list.appKey = v
              list.refId = ''
              for (let i = 0; i < _this.appOp.length; i++) {
                if (v === _this.appOp[i].appKey) {
                  list.refId = _this.appOp[i].refId
                  break;
                } else {
                  list.refId = ''
                }
              }
              appOP.push(list)
            })
            console.log(appOP)
            let params = {
              objectId: this.objForm.objectId,
              objectName: this.objForm.objectName,
              telNum: this.objForm.telNum,
              sysIds: sysIds,
              appKeyList: appOP,
              email: this.objForm.email,
              objectDesc: this.objForm.objectDesc
            }
            this.$axios
              .post(this.$API.warning.updateAlarmObject, params)
              // .post('http://172.16.9.104:5010/agw/alarmObjectCtr/updateAlarmObject', params)
              .then(function (r) {
                _self.dialogFormVisible = false
                _self.$message({
                  type: 'success',
                  message: '保存成功'
                })
                _self.queryList()
              })
              .catch(function (error) {})
          }
        })
      } else if (this.dialogStatus == 'addObj') {
        this.$refs[formName].validate(valid => {
          if (valid) {
            let _self = this
            let sysIds = []
            if (this.objForm.sysId) {
              sysIds.push(this.objForm.sysId)
            }
            let params = {
              objectName: this.objForm.objectName,
              telNum: this.objForm.telNum,
              email: this.objForm.email,
              sysIds: sysIds,
              appKeyList: this.objForm.appKey,
              objectDesc: this.objForm.objectDesc
            }
            this.$axios
              .post(this.$API.warning.addAlarmObject, params)
              // .post('http://172.16.9.104:5010/agw/alarmObjectCtr/addAlarmObject', params)
              .then(function (r) {
                _self.dialogFormVisible = false
                _self.$message({
                  type: 'success',
                  message: '保存成功'
                })
                _self.queryList()
              })
              .catch(function (error) {})
          }
        })
      }
    },
    /* 删除 */
    handleDelete (index, row) {
      let params = {
        objectId: row.objectId
      }
      this.$confirm('确认是否删除此预警对象?', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let _self = this
          this.$axios
            .get(this.$API.warning.deleteAlarmObject, { params: params})
            .then(function (r) {
              _self.dialogFormVisible = false
              _self.$message({
                type: 'success',
                message: '删除成功'
              })
              _self.queryList()
            })
            .catch(function (error) {})
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    /* 关闭弹窗 */
    closeDialog (formName) {
      this.dialogFormVisible = false
      /* 关闭对话框清除验证和表单内容 */
      this.$refs[formName].resetFields()
      this.objForm.objectId = ''
      this.objForm.objectName = ''
      this.objForm.telNum = ''
      this.objForm.email = ''
      this.objForm.sysId = ''
      this.objForm.appKey = []
      this.appOp = []
      this.objForm.objectDesc = ''
    },
    /* 重置操作 */
    onReset (formName) {
      this.$refs[formName].resetFields()
    },
    // 每页显示多少条
    pageSizeChange (val) {
      this.page.size = val
      this.page.num = 1
      this.queryList()
    },
    // 当前页选择
    pageCurrentChange (val) {
      this.page.num = val
      this.queryList()
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/warning/objectManagement.js